import { default as Modal } from 'antd/es/modal';

import type { McpToken } from 'api';

import { PrimaryButton } from '@atoms/buttons/PrimaryButton';
import { SecondaryButton } from '@atoms/buttons/SecondaryButton';

import {
  REVOKE_MCP_CANCEL_TEST_ID,
  REVOKE_MCP_CONFIRM_LABEL,
  REVOKE_MCP_CONFIRM_TEST_ID,
  REVOKE_MCP_MODAL_TEST_ID,
  REVOKE_MCP_TITLE,
  revokeMcpBody
} from './constants';
import { useRevokeMcpToken } from './useRevokeMcpToken';

type RevokeMcpTokenModalProps = {
  token: McpToken;
  open: boolean;
  onCancel: () => void;
  onConfirmed: () => void;
};

export const RevokeMcpTokenModal = ({
  token,
  open,
  onCancel,
  onConfirmed
}: RevokeMcpTokenModalProps) => {
  const { revoke, isPending } = useRevokeMcpToken();

  const cancel = () => {
    if (isPending) return;
    onCancel();
  };

  return (
    <Modal
      open={open}
      onCancel={cancel}
      width={420}
      destroyOnHidden
      closable={!isPending}
      maskClosable={!isPending}
      keyboard={!isPending}
      title={
        <div className="text-lg font-medium text-content-primary">
          {REVOKE_MCP_TITLE}
        </div>
      }
      footer={
        <div className="flex justify-end gap-2">
          <SecondaryButton
            data-testid={REVOKE_MCP_CANCEL_TEST_ID}
            onClick={cancel}
            disabled={isPending}
          >
            Cancel
          </SecondaryButton>
          <PrimaryButton
            data-testid={REVOKE_MCP_CONFIRM_TEST_ID}
            danger
            type="default"
            loading={isPending}
            disabled={isPending}
            onClick={() => revoke(token, onConfirmed)}
          >
            {REVOKE_MCP_CONFIRM_LABEL}
          </PrimaryButton>
        </div>
      }
    >
      <p
        data-testid={REVOKE_MCP_MODAL_TEST_ID}
        className="text-base text-content-primary"
      >
        {revokeMcpBody(token.name)}
      </p>
    </Modal>
  );
};
